























































































import { ref, createComponent, Ref, onMounted, reactive, computed } from '@vue/composition-api'
import axios from 'axios'
import { getTaskList, GetTaskListParams, TableItem, handlePagination } from '@/service/transferList'
import { formatFileSize, getFileIcon } from '@/helpers/common'

export default createComponent({
    setup(props, setupContext) {
        const tableData = ref<TableItem[]>([])
        const { handleCurrentChange, pageSize, currentPageNum, currentList, updateCurrentList } = handlePagination(
            tableData
        )
        const useSearch = search(tableData)
        const handleSearch = async () => {
            await useSearch.onSearch()
            updateCurrentList()
        }
        onMounted(async () => {
            currentPageNum.value = 1
            handleSearch()
        })
        return {
            getFileIcon,
            tableData,
            currentList,
            ...useSearch,
            handleSearch,
            pageSize,
            handleCurrentChange,
        }
    },
})

function search(tableData: Ref<TableItem[]>) {
    const searchParam = reactive({
        search: '',
        // dateRange: [new Date(Date.now() - 60 * 60 * 1000), new Date()]
        dateRange: [],
    })

    const onSearch = async () => {
        const params: GetTaskListParams = {
            types: '0,1',
            status: '3',
        }
        if (searchParam.search) {
            params.search = searchParam.search
        }
        if (searchParam.dateRange && searchParam.dateRange.length) {
            params.startTime = searchParam.dateRange[0]
            params.endTime = searchParam.dateRange[1]
        }
        const res = await getTaskList(params)
        if (res.code === 0) {
            tableData.value = res.data.map(item => {
                item.size = formatFileSize(item.totalSize)
                return item
            })
        } else {
            tableData.value = []
        }
    }

    return {
        searchParam,
        onSearch,
    }
}
